import { createAction } from '@reduxjs/toolkit';

export const setQueryClientAction = createAction<any>('SET_QUERY_CLIENT_SAGA');

export const setFeatureFlagAction = createAction<any>('SET_FEATURE_FLAG');
